import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import { IntlProvider } from 'react-intl';
import { ThemeProvider } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import { nebuleaTheme } from "./nebuleaTheme";

import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-pluralrules/dist/locale-data/en';
import '@formatjs/intl-pluralrules/dist/locale-data/fr';

import messagesEn from './translations/en.json';
import messagesFr from './translations/fr.json';
import messagesNl from './translations/nl.json';
import messagesEs from './translations/es.json';

import reducers from './reducers';
import App from './App';
import * as serviceWorker from './serviceWorker';
import history from './history';

import '@fortawesome/fontawesome-free/css/all.min.css';
import 'bootstrap-css-only/css/bootstrap.min.css';
import 'react-phone-number-input/style.css';

import './assets/scss/mdb.scss';
import { initSentry, registerSentryRouting } from './modules/sentry';

// Context -------------------------------------
import { MobileProvider } from './modules/MobileContext';

const composeEnhancers =
  typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      // Specify extension’s options like name, actionsBlacklist, actionsCreators, serialize...
    })
    : compose;

const enhancer = composeEnhancers(applyMiddleware(thunkMiddleware));
const store = createStore(reducers, enhancer);
// const store = createStore(reducers, applyMiddleware(thunkMiddleware));

const messages = {
  fr: messagesFr,
  en: messagesEn,
  nl: messagesNl,
  es: messagesEs
};

let language = navigator.language.split(/[-_]/)[0]; // language without region code
if (messages[language] === undefined) {
  language = 'en'; // default
}

//var myScreenOrientation = window.screen.orientation;
//myScreenOrientation.lock("portrait");

initSentry();
registerSentryRouting(history);

render(
  <ThemeProvider theme={nebuleaTheme}>
    <CssBaseline />
    <Provider store={store}>
      <MobileProvider>
        <IntlProvider locale={language} messages={messages[language]}>
          <App />
        </IntlProvider>
      </MobileProvider>
    </Provider>
  </ThemeProvider>,
  document.getElementById('root')
);

serviceWorker.register();
